export default function () {
  return {
    agreementId: undefined,
    year: undefined,
    contractCode: undefined,
    productComponentCodesToIgnore: [],
    newlyParticipantCustomerNumbers: [],

    showDenialReason: false,
    denialReasonData: undefined,
    showMedicalSelectionOverlay: false,
    medicalSelectionOverlayData: undefined,
    showRejected: false,
    rejectedData: undefined,
  };
}
